<template lang="html">
  <b-container>
    <b-row>
      <b-col>
        <p />
      </b-col>
      <b-col md="4" class="address">
        <p>Tungite Labs, LLC</p>
        <p>P.O. Box 2999</p>
        <p>Greenville, NC 27858</p>
        <p>U.S.A.</p>
        <p>soundslides.com</p>
      </b-col>
    </b-row>
    <b-row>
      <b-col v-if="$store.state.authorized">
        <div v-if="user_doc.paypal_result">
          <div v-if="version == 'receipt'" class="mt-3">
            <h1>Receipt</h1>
          </div>

          <div v-else class="mt-3">
            <h1>Invoice</h1>
          </div>

          <h3 class="text-muted">#{{ item_id }}</h3>

          <h4 class="text-muted">
            {{
              parseDate(
                user_doc.paypal_result.agreement_details.last_payment_date
              )
            }}
          </h4>

          <h5 class="mt-5">
            {{ user_doc.paypal_result.payer.payer_info.first_name }}
            {{ user_doc.paypal_result.payer.payer_info.last_name }}
          </h5>
          <h5>{{ user_doc.paypal_result.payer.payer_info.email }}</h5>

          <div class="address mt-4">
            <p>
              {{
                user_doc.paypal_result.payer.payer_info.shipping_address.line1
              }}
            </p>
            <p>
              {{
                user_doc.paypal_result.payer.payer_info.shipping_address.line2
              }}
            </p>
            <p>
              {{
                user_doc.paypal_result.payer.payer_info.shipping_address.city
              }},
              {{
                user_doc.paypal_result.payer.payer_info.shipping_address.state
              }},
              {{
                user_doc.paypal_result.payer.payer_info.shipping_address
                  .postal_code
              }}
            </p>
            <p>
              {{
                user_doc.paypal_result.payer.payer_info.shipping_address
                  .country_code
              }}
            </p>
          </div>

          <h3 class="mt-5">Product</h3>

          <p class="mb-5">Item: {{ user_doc.paypal_result.description }}</p>

          <div v-if="version == 'receipt'">
            <h3>
              Payment details
            </h3>

            <p>
              Amount paid: ${{
                user_doc.paypal_result.agreement_details.last_payment_amount
                  .value
              }}
              {{
                user_doc.paypal_result.agreement_details.last_payment_amount
                  .currency
              }}
            </p>

            <p>
              Paid via PayPal on
              {{
                parseDate(
                  user_doc.paypal_result.agreement_details.last_payment_date
                )
              }}.
            </p>

            <h4 class="mt-4">Balance due: $0.00</h4>
          </div>

          <div v-if="version == 'invoice'">
            <h3>
              Invoice details
            </h3>

            <p>
              Amount:
              {{
                user_doc.paypal_result.agreement_details.last_payment_amount
                  .value
              }}
              {{
                user_doc.paypal_result.agreement_details.last_payment_amount
                  .currency
              }}
            </p>

            <p>
              Invoice due on
              {{
                parseDate(
                  user_doc.paypal_result.agreement_details.last_payment_date
                )
              }}
            </p>

            <h4 class="mt-4">
              Balance due: $0.00
            </h4>

            <p class="alert alert-info mt-3">
              This invoice has been paid.
              <b-link
                :to="{
                  name: 'account-latest-transaction',
                  params: { version: 'receipt' }
                }"
                variant="dark"
              >
                View payment receipt.
              </b-link>
            </p>
          </div>

          <div class="mt-5">
            <b-btn
              v-if="version == 'receipt'"
              size="sm"
              variant="outline-secondary"
              :to="{
                name: 'account-latest-transaction',
                params: { version: 'invoice' }
              }"
            >
              View invoice
            </b-btn>
            <b-btn
              v-if="version == 'invoice'"
              size="sm"
              variant="outline-secondary"
              :to="{
                name: 'account-latest-transaction',
                params: { version: 'receipt' }
              }"
            >
              View receipt
            </b-btn>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { parseISO, format } from "date-fns";
export default {
  name: "RecentPayPalTransaction",
  components: {},
  data() {
    return {};
  },
  computed: {
    user_doc() {
      return this.$store.state.user_doc;
    },
    version() {
      return this.$route.params.version;
    },
    item_id() {
      var payment_date = parseISO(
        this.user_doc.paypal_result.agreement_details.last_payment_date
      );
      return (
        format(payment_date, "yyyy") +
        "-" +
        format(payment_date, "MM") +
        "-" +
        this.user_doc.paypal_result.id
      );
    }
  },
  mounted() {
    if (!("paypal_result" in this.user_doc)) {
      this.$router.push({ name: "account" });
    }
  },
  methods: {
    parseDate(date_string) {
      return format(parseISO(date_string), "MMMM d, yyyy");
    }
  }
};
</script>

<style lang="css" scoped>
.address {
  line-height: 0.7em;
}
</style>
